module.exports = "<h2>\n    <mat-icon style=\"vertical-align: middle\">error</mat-icon>&nbsp; {{loc.get('DialogOverQueryTitle')}}\n</h2>\n<p [innerHTML]=\"loc.get('DialogOverQueryBody')\"></p>\n<div style=\"text-align: right; margin-top: 10px\">\n  <button mat-raised-button (click)=\"closeDialog()\">{{loc.get('Chiudi')}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialogs/over-query-limit-dialog/over-query-limit-dialog.html
// module id = ./src/app/dialogs/over-query-limit-dialog/over-query-limit-dialog.html
// module chunks = main